import { apiClient } from './apiClient';

const base = '/api/callme';

export const callMeService = {
  // Send OTP to phone number (API expects 'phone' not 'phoneNumber')
  sendOtp: phone => apiClient.post(`${base}/send-otp`, { phone }),

  // Verify OTP (API expects 'phone' not 'phoneNumber')
  verifyOtp: (phone, otp) => apiClient.post(`${base}/verify-otp`, { phone, otp }),

  // Start outbound call (API expects 'agentId' or 'agentKey')
  startCall: agentId => apiClient.post(`${base}/start-call`, { agentId }),
};

export default callMeService;
